import { render, staticRenderFns } from "./SidebarSaveLikeATemplate.vue?vue&type=template&id=53c09ec6&scoped=true&"
import script from "./SidebarSaveLikeATemplate.vue?vue&type=script&lang=js&"
export * from "./SidebarSaveLikeATemplate.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSaveLikeATemplate.vue?vue&type=style&index=0&id=53c09ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c09ec6",
  null
  
)

export default component.exports